import { JSX } from 'react'
import { $isLinkNode, TOGGLE_LINK_COMMAND } from '@lexical/link'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { $findMatchingParent } from '@lexical/utils'
import {
  $getSelection,
  $isRangeSelection,
  $isTextNode,
  CLICK_COMMAND,
  COMMAND_PRIORITY_LOW,
} from 'lexical'
import { useEffect, useState } from 'react'

import { LinkFormModal, LinkFormModalValues } from '../LinkFormModal'
import { getSelectedNode } from '../utils'

export const EditLinkPlugin = (): JSX.Element | null => {
  const [editor] = useLexicalComposerContext()
  const [showModal, setShowModal] = useState(false)
  const [selectedLink, setSelectedLink] = useState<LinkFormModalValues>({
    text: '',
    link: '',
  })

  const handleOnDelete = () => {
    editor.update(() => {
      const selection = $getSelection()

      if ($isRangeSelection(selection)) {
        const node = getSelectedNode(selection)
        const linkNode = $findMatchingParent(node, $isLinkNode)

        if ($isLinkNode(linkNode)) {
          editor.dispatchCommand(TOGGLE_LINK_COMMAND, null)
        }
      }
    })
  }

  const handleOnSave = ({ link, text }: LinkFormModalValues) => {
    editor.update(() => {
      const selection = $getSelection()

      if ($isRangeSelection(selection)) {
        const node = getSelectedNode(selection)
        const linkNode = $findMatchingParent(node, $isLinkNode)

        if ($isLinkNode(linkNode)) {
          const currentText = linkNode.getTextContent()

          linkNode.setURL(link)

          linkNode.getChildren().some((child) => {
            if ($isTextNode(child) && child.getTextContent() === currentText) {
              child.setTextContent(text)
              return true
            }
            return false
          })
        }
      }
    })
  }

  useEffect(() => {
    editor.registerCommand(
      CLICK_COMMAND,
      () => {
        const selection = $getSelection()

        if ($isRangeSelection(selection)) {
          const node = getSelectedNode(selection)
          const linkNode = $findMatchingParent(node, $isLinkNode)

          if ($isLinkNode(linkNode)) {
            const text = linkNode.getTextContent()
            const link = linkNode.getURL()

            setSelectedLink({ text, link })
            setShowModal(true)

            return true
          }
        }

        return false
      },
      COMMAND_PRIORITY_LOW
    )
  }, [editor])

  return (
    <LinkFormModal
      show={showModal}
      onSave={handleOnSave}
      onClose={() => setShowModal(false)}
      onDelete={handleOnDelete}
      value={selectedLink}
      edit
    />
  )
}
